import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domain-specific',
  templateUrl: './domain-specific.component.html',
  styleUrls: ['./domain-specific.component.scss']
})
export class DomainSpecificComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
